import { useState, useEffect, useRef } from 'react'
import './Hero.css'

const Hero = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0)
  const videoRefs = useRef<(HTMLVideoElement | null)[]>([])

  const videos = [
    '/videos/video1.mp4',
    '/videos/video2.mp4',
    '/videos/video3.mp4',
  ]

  const scrollToSection = (href: string) => {
    const target = document.querySelector(href)
    if (target) {
      const offsetTop = (target as HTMLElement).offsetTop - 80
      window.scrollTo({ top: offsetTop, behavior: 'smooth' })
    }
  }

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentVideoIndex((prevIndex) => (prevIndex + 1) % videos.length)
    }, 8000)

    const currentVideo = videoRefs.current[currentVideoIndex]
    if (currentVideo) {
      currentVideo.play().catch(console.error)
    }

    videoRefs.current.forEach((video, index) => {
      if (video && index !== currentVideoIndex) {
        video.pause()
        video.currentTime = 0
      }
    })

    return () => clearInterval(interval)
  }, [currentVideoIndex, videos.length])

  return (
    <section id="home" className="hero">
      <div className="hero-video-container">
        {videos.map((videoSrc, index) => (
          <video
            key={videoSrc}
            ref={(el) => (videoRefs.current[index] = el)}
            className={`hero-video ${index === currentVideoIndex ? 'active' : ''}`}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
          >
            <source src={videoSrc} type="video/mp4" />
          </video>
        ))}
      </div>
      <div className="hero-overlay">
        <div className="hero-container">
          <div className="hero-content">
            <p className="hero-eyebrow">Welcome — you are in the right place</p>
            <h1 className="hero-headline">
              Give Your Family
              <br />
              <em>Peace of Mind</em>
            </h1>
            <p className="hero-subheadline">
              Even when you're not there, your voice can still guide them home.
              ECHO brings calm, clarity, and comfort to the people you love most.
            </p>
            <div className="hero-cta">
              <button
                className="btn btn-primary"
                onClick={() => scrollToSection('#legacy-books')}
              >
                Explore Legacy Books
              </button>
              <button
                className="btn btn-secondary hero-btn-secondary"
                onClick={() => scrollToSection('#about')}
              >
                Learn How We Help
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero
